import SystemDatesSettings from './SystemDatesSettings'

export default SystemDatesSettings
